import React from 'react';
import CharacterCard from './CharacterCard';

/**
 * CharacterBrowserGrid Component
 * Displays a responsive grid of character cards
 */
const CharacterBrowserGrid = ({ characters, type = 'predefined' }) => {
  if (!characters || characters.length === 0) {
    return (
      <div className="text-center py-12">
        <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
        <h3 className="mt-2 text-sm font-medium text-gray-900">No characters found</h3>
        <p className="mt-1 text-sm text-gray-500">No characters available.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {characters.map((character) => (
        <CharacterCard
          key={character.characterId}
          character={character}
          type={character._type || type}
        />
      ))}
    </div>
  );
};

export default CharacterBrowserGrid;
